import AiDocumentTable from './AiDocumentTable'

export default AiDocumentTable
